import { useEffect, useState } from "react";

/**
 * Simple QR code component that uses the free qrserver.com API (no dependencies).
 * Falls back to a link if the API blocks. Works offline once cached.
 */
export default function DemoQRCode({ size = 180, url, caption = "Scan to see the demo" }) {
  const [target, setTarget] = useState(url || "");

  useEffect(() => {
    if (url) {
      setTarget(url);
      return;
    }
    if (typeof window !== "undefined") {
      setTarget(`${window.location.origin}/demo`);
    }
  }, [url]);

  if (!target) return null;
  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=6&data=${encodeURIComponent(target)}`;

  return (
    <div className="inline-flex flex-col items-center gap-2 p-3 bg-white rounded-lg border-2 border-[hsl(var(--gold))]/60 shadow-md" data-testid="demo-qr">
      <img
        src={qrSrc}
        alt="QR code — scan to see Decline Drive demo"
        width={size}
        height={size}
        className="rounded"
        data-testid="demo-qr-img"
      />
      <div className="font-mono-label text-navy text-[0.6rem] tracking-widest text-center max-w-[180px]">
        {caption}
      </div>
    </div>
  );
}
